<div class="navigation vex-menubar-wrapper" [class.vex-menubar-in-toolbar]="inToolbar" vexContainer>
  <p-menubar #menubarRef
             [model]="menuItems"
             styleClass="vex-menubar"
             [autoDisplay]="true"
             [autoHide]="true"
             [autoHideDelay]="0" />
</div>

